import { useUrlState } from '@/lib/useUrlState';
import { cn } from '@/lib/utils';
import { LostDealsPage } from '@/pages/LostDealsPage';
import { PipelinePage } from '@/pages/PipelinePage';

const FILTER = ['alle', 'verloren'] as const;
type Filter = (typeof FILTER)[number];

const FILTER_LABEL: Record<Filter, string> = {
  alle: 'Alle',
  verloren: 'Verloren',
};

/**
 * Der Reiter „Brett“: das Akquise-Brett mit der Filterzeile Alle · Verloren.
 *
 * „Alle“ ist das Brett von der ersten Antwort bis zur Zusage, mit dem
 * Umschalter für die Zielgruppe und dem Übernahme-Knopf an der Zusage-Spalte.
 * „Verloren“ ist die Liste der Absagen über alle Zielgruppen — mit Grund,
 * Wiederaufnehmen und eigener Suche. Der Filter steht in der URL (`?filter=`),
 * damit der Zurück-Knopf aus einer Kontaktakte wieder dort landet.
 */
export function BrettTab() {
  const [filter, setFilter] = useUrlState<Filter>('filter', 'alle', FILTER);

  return (
    <div className="space-y-4">
      <div
        className="flex w-fit gap-1 rounded-lg border border-border bg-card p-1"
        role="group"
        aria-label="Brett filtern"
      >
        {FILTER.map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            aria-pressed={filter === f}
            className={cn(
              'rounded-md px-3 py-1.5 text-sm transition-colors',
              filter === f ? 'bg-primary text-primary-foreground' : 'hover:bg-muted',
            )}
          >
            {FILTER_LABEL[f]}
          </button>
        ))}
      </div>

      {filter === 'verloren' ? (
        <LostDealsPage />
      ) : (
        <PipelinePage onZeigeVerlorene={() => setFilter('verloren')} />
      )}
    </div>
  );
}
